
import { ProductConfig, VariantOption } from './types';

const DEFAULT_HEADBOARD_VARIANTS: VariantOption[] = [
  { id: 'v-r', label: 'R', priceModifier: 0 },
  { id: 'v-m', label: 'M', priceModifier: 0 },
  { id: 'v-xl', label: 'XL', priceModifier: 120 },
  { id: 'v-xxl', label: 'XXL', priceModifier: 200 },
];

const createEmptyItems = (prefix: string, count: number, hasVariants: boolean = false) => {
  return Array.from({ length: count }, (_, i) => ({
    id: `${prefix}${i + 1}`,
    name: `Model ${i + 1}`,
    priceModifier: 0,
    imageUrl: '',
    imageUrlFront: '',
    ...(hasVariants ? { variants: JSON.parse(JSON.stringify(DEFAULT_HEADBOARD_VARIANTS)) } : {})
  }));
};

export const INITIAL_CONFIG: ProductConfig = {
  id: 'boxspring-pro-v4',
  name: 'Elysian Premium Boxspring',
  basePrice: 1290,
  noneTopperImageUrl: '',
  noneTopperImageUrlFront: '',
  sizes: [
    { id: 's1', label: '140x200', width: 140, length: 200, priceModifier: 0 },
    { id: 's2', label: '160x200', width: 160, length: 200, priceModifier: 150 },
    { id: 's3', label: '180x200', width: 180, length: 200, priceModifier: 300 },
    { id: 's4', label: '200x200', width: 200, length: 200, priceModifier: 500 },
  ],
  colors: [
    { id: 'c1', name: 'Antraciet Geweven', hex: '#374151', fabricType: 'Stof', priceModifier: 0 },
    { id: 'c2', name: 'Crème Fluweel', hex: '#f5f5f4', fabricType: 'Velvet', priceModifier: 100 },
    { id: 'c3', name: 'Lichtgrijs Linnen', hex: '#d1d5db', fabricType: 'Linen', priceModifier: 0 },
    { id: 'c4', name: 'Beige Soft', hex: '#e7e5e4', fabricType: 'Stof', priceModifier: 0 },
    { id: 'c5', name: 'Nachtblauw', hex: '#1e3a8a', fabricType: 'Velvet', priceModifier: 120 },
    { id: 'c6', name: 'Saliegroen', hex: '#4b5e4b', fabricType: 'Linen', priceModifier: 80 },
    { id: 'c7', name: 'Aardebruin', hex: '#451a03', fabricType: 'Woven', priceModifier: 50 },
    { id: 'c8', name: 'Oudroze', hex: '#9d7a7a', fabricType: 'Velvet', priceModifier: 120 },
    { id: 'c9', name: 'Houtskool Zwart', hex: '#111827', fabricType: 'Stof', priceModifier: 0 },
    { id: 'c10', name: 'Hemelblauw', hex: '#7dd3fc', fabricType: 'Linen', priceModifier: 80 },
  ],
  headboards: createEmptyItems('h', 9, true),
  bases: createEmptyItems('b', 7),
  mattresses: createEmptyItems('m', 3),
  toppers: createEmptyItems('t', 3),
  poets: createEmptyItems('p', 4),
  voetbords: createEmptyItems('v', 2),
  voets: createEmptyItems('vt', 2),
  nightstands: createEmptyItems('n', 2)
};
